import React, { useState } from 'react';
import _ from 'lodash';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ErrorMessage } from 'formik';
import { t } from 'i18next';
import images from 'assets/images';

const ReactstrapFormikInput = ({ field: { ...fields }, form: { touched, errors }, ...props }) => {
    const { id, ...rest } = props;
    const [showPassword, setShowPassword] = useState(false);
    const isInValid = Boolean(_.get(touched, fields.name) && _.get(errors, fields.name));

    const onShowPassword = () => {
        setShowPassword(!showPassword);
    };
    return (
        <Form.Group controlId={id} className="form-group">
            {props.showDetailTooltip
                ? props.label && (
                      <Form.Label className={'label-color'}>
                          <div className="d-flex">
                              {props.label}
                              <div style={{ cursor: 'pointer', marginTop: '2px', marginLeft: '5px' }}>
                                  <OverlayTrigger
                                      placement={'right'}
                                      overlay={
                                          <Tooltip id={`tooltip-top`} className="custom-detail-tooltip">
                                              <span>{props.detail}</span>
                                          </Tooltip>
                                      }
                                  >
                                      <img id="app-title" src={images.icinformationSVG} width="14px" />
                                  </OverlayTrigger>
                              </div>
                          </div>
                      </Form.Label>
                  )
                : props.label && <Form.Label className={'label-color'}>{props.label}</Form.Label>}
            <div
                className={
                    props.type && props.type === 'password' ? `password-block ${!showPassword ? '' : 'show'}` : ''
                }
            >
                <Form.Control
                    {...fields}
                    {...rest}
                    isInvalid={isInValid}
                    className={props.type && props.type === 'password' && isInValid ? 'img-remove' : ''}
                    type={props.type && props.type === 'password' ? (showPassword ? 'text' : 'password') : props.type}
                />
                {props.type && props.type === 'password' && (
                    <span
                        className="password-icon"
                        onClick={onShowPassword}
                        title={!showPassword ? t('login.label.showPassword') : t('login.label.hidePassword')}
                    ></span>
                )}
            </div>
            <ErrorMessage name={fields.name}>
                {(msg) =>
                    msg !== 'required' ? (
                        <Form.Control.Feedback className="pb-0 error invalid-feedback d-block" type="invalid">
                            {msg}
                        </Form.Control.Feedback>
                    ) : (
                        ''
                    )
                }
            </ErrorMessage>
        </Form.Group>
    );
};
export default ReactstrapFormikInput;
